import { Component } from '@angular/core';
import { HomePage } from '../home/home';
import { MycartPage } from '../mycart/mycart';
import { CheckoutPage } from '../checkout/checkout';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { ProductService} from '../service/product_service'

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {
  mySelectedIndex:number;
  tab1Root = HomePage;
  tab2Root = MycartPage;
  tab3Root = CheckoutPage;
  navDataParam:any;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams,
    public prodService:ProductService,
    public loadingCtrl : LoadingController) {
    this.mySelectedIndex = navParams.data.tabIndex || 0;
    this.navDataParam={
      categoryId:this.navParams.data.categoryId || 0,
      subCategoryId:this.navParams.data.subCategoryId || 0,
      brandId:this.navParams.data.brandId || 0,
      productTypeId:this.navParams.data.productTypeId || 0,
      vendorId:this.navParams.data.vendorId || 0
    }
    
  }
  AddFalseLoadingBar(){

    //create loader
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
  
    //show loader
    loading.present();

    setTimeout(function(){
      loading.dismiss();
    },1000);
   }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts